import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Actions from '@wetransfer/transfer/store/action';

import { Metadata, useMetadataQuery } from './useMetadataQuery';

export function useMetadata(): {
  metadata: Metadata;
  fetching: boolean;
} {
  const { data, fetching } = useMetadataQuery();
  const dispatch = useDispatch();

  useEffect(() => {
    if (data?.metadata) {
      dispatch(
        Actions.Session.setMaxFileSizes({
          maxWallpaperSize: parseInt(data.metadata.fileSizes.maxWallpaperSize),
          maxProfilePictureSize: parseInt(
            data.metadata.fileSizes.maxProfilePictureSize
          ),
          maxEmailBackgroundSize: parseInt(
            data.metadata.fileSizes.maxEmailBackgroundSize
          ),
        })
      );
      dispatch(
        Actions.Session.setTransferExpiryOptions(
          data.metadata.transferExpirationOptions
        )
      );
      dispatch(Actions.Session.setRegion(data.metadata.region));
      dispatch(Actions.Session.setCookieDomain(data.metadata.cookieDomain));
    }
  }, [data?.metadata, dispatch]);

  return { metadata: data?.metadata, fetching };
}
